import { useQuery } from '@tanstack/react-query';

import { fetchPatientAllergiesByUserId } from '../api/getPatientAllergiesByUserId.js';
import { rxKeys } from './keys.js';

export function patientAllergiesQueryDefinition(userId: string) {
  return {
    queryKey: rxKeys.patientAllergies(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPatientAllergiesByUserId(userId, signal),
    meta: {
      toast: {
        title: 'Could not load patient allergies',
        description: 'Patient allergies could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePatientAllergiesQuery(userId: string | undefined) {
  return useQuery({
    ...patientAllergiesQueryDefinition(userId ?? ''),
    enabled: !!userId,
  });
}
